$(document).ready(function () {
  $('.menutrigger').on('click', function() {
    $('.slide_in_menu').toggleClass('slide_in_menu_open');
  })
});